export default "__VITE_ASSET__514ad49a__"